import { useMemo } from "react";

/** Pure check usable outside React (e.g. the axios interceptor). */
export const isClientPanelHostname = (
  hostname: string = window.location.hostname,
) => {
  const hostParts = hostname.split(".");

  if (hostParts.length < 3) {
    return false;
  }

  return ["klient", "localklient"].includes(hostParts[0]);
};

export const useClientPanel = () => {
  const hostname = window.location.hostname;

  const isClientPanel = useMemo(
    () => isClientPanelHostname(hostname),
    [hostname],
  );

  return {
    isClientPanel: isClientPanel,
  };
};
